/**
 * Creates function for handling CSS or JS output
 *
 * @param value String default string
 * @param append String the value to append
 *
 * @return Function This
 *
 * @example
 * const red = token("red")
 * red(); // "red"
 * red(true) // "red !default;";
 * red(); // "red"
 * red(true, "!important;") // "red !important;";
 */
export default function serializeToken(value, append) {
    if (typeof value === "string") {
        append = append === undefined ? "!default;" : append;
        if (typeof append === "string") {
            /**
             * Define the outputformat
             * @param css {Boolean} define if the output is css or not
             * @return {String}
             */
            return (css) => {
                // Serialize css
                if (css) {
                    const val = `${value} ${append};`;
                    return val.replace(/(;+)$/, ";");
                }
                //Default is the raw value
                return value;
            };
        }
    }
    return value;
}
